import DropDown from "@components/Dropdown";
import UserIcon from "@components/UserIcon";
import useI18n from "@contexts/I18nProvider/hooks/useI18n";
import useSignOut from "@hooks/useSignOut";
import { userContext } from "@layouts/App/context/User";
import { A, useNavigate } from "@solidjs/router";
import { FaSolidAngleDown, FaSolidArrowRightFromBracket } from "solid-icons/fa";
import { IoChatbubblesOutline, IoSettingsOutline } from "solid-icons/io";
import { useContext } from "solid-js";
import { DropdownArrow, DropdownButton, UserRowWrapper } from "./styled";

const UserRow = () => {
	const { user } = useContext(userContext);
	const { t } = useI18n();
	const signout = useSignOut();
	const navigate = useNavigate();
	return (
		<UserRowWrapper justifyContent="space-between" alignItems="center" padding="20px 0 40px">
			<A href={`/profile/${user.uid}`}>
				<UserIcon diameter="80px" src={user.photo} alt={user.nickname} />
			</A>
			<DropDown
				items={[
					{ label: t("app.nav.history"), icon: <IoChatbubblesOutline />, onClick: () => navigate("/history") },
					{
						label: t("app.nav.settings"),
						icon: <IoSettingsOutline />,
						onClick: () => navigate(window.innerWidth <= 1700 ? "/settings" : "/settings/preferences"),
					},
					{ label: t("app.nav.logout"), icon: <FaSolidArrowRightFromBracket />, onClick: signout },
				]}
			>
				<DropdownButton
					iconPosition="right"
					icon={
						<DropdownArrow>
							<FaSolidAngleDown />
						</DropdownArrow>
					}
				>
					{user.nickname}
				</DropdownButton>
			</DropDown>
		</UserRowWrapper>
	);
};
export default UserRow;
